import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'

export default function useGetFirstOnboardingPage(): string {
  return useGetGradePageRoute({ isOnboarding: true })
}
